// prebuilt icons from heroicons. export here so we can customized them later without needing to know where it came from
export { XMarkIcon as XIcon, ArrowSmallLeftIcon } from "@heroicons/react/24/outline"

// some default constants to help standardize classes across the theme
export { IconSizeClasses, IconColorClasses, MapControlIconSizeClasses } from "./constants"

export { SatelliteMapIcon, LightMapIcon, WhiteMapIcon, DarkMapIcon } from "./map-styles"

// export type { IconComponent } from "./types"
export { VisibleIcon, NotVisibleIcon } from "./visibility"
